module.exports = __webpack_public_path__ + "dental candidate profile.png?363af9be029ef49a652e7ad96f5824c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/dental candidate profile.png
// module id = 362
// module chunks = 0